var map = {
	"./Countdown": 7,
	"./Countdown.js": 7,
	"./ExamCountdown": 9,
	"./ExamCountdown.js": 9,
	"./NewTest": 10,
	"./NewTest.js": 10,
	"./StartExam": 15,
	"./StartExam.js": 15
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23;


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components ^\.\/.*$
// module id = 23
// module chunks = 0 1